import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsEpicgamesComponent } from './simple-icons-epicgames.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsEpicgamesComponent ],
    exports:      [ SimpleIconsEpicgamesComponent ],
    bootstrap:    []
})
export class SimpleIconsEpicgamesModule {}
